export default function HammondHeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex flex-col">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Hammond%20Louisiana%20Southeastern%20Louisiana%20University%20campus%20lush%20green%20trees%20college%20town%20USA%20aerial%20view%20suburban%20city%20vibrant%20community%20artistic%20warm%20tones%20editorial%20photography%20wide%20angle&width=1600&height=900&seq=hammond-la-hero-2026&orientation=landscape"
          alt="Hammond Louisiana"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      {/* Navbar */}
      <nav className="relative z-20 w-full px-4 md:px-8 py-5 flex items-center justify-between">
        <a href="https://fastpassportcenter.com" className="flex-shrink-0">
          <img
            src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/02/logo-nav-white.svg"
            alt="Fast Passport Center"
            className="h-8 w-auto"
          />
        </a>
        <div className="flex items-center gap-3">
          <a
            href="tel:8772530084"
            className="hidden md:inline-flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line text-[#F6C344]"></i> 877-253-0084
          </a>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-4 md:px-8 py-16 w-full">
        <div className="inline-flex items-center gap-2 bg-[#F6C344]/20 border border-[#F6C344]/40 text-[#F6C344] text-xs font-bold px-4 py-2 rounded-full uppercase tracking-widest mb-5">
          <i className="ri-passport-line"></i> Hammond, Louisiana
        </div>
        <h1 className="font-serif text-4xl md:text-6xl font-bold text-white mb-4 leading-tight max-w-4xl">
          Emergency & Expedited Passport Services in <span className="text-[#F6C344]">Hammond, LA</span>
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-2xl mb-8 leading-relaxed">
          Serving Tangipahoa Parish — including SLU students, Northshore commuters, and families throughout the I-12 corridor. Get your passport as fast as 24 hours.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-10">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 text-white hover:text-[#F6C344] font-medium text-base transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line text-[#F6C344]"></i> Call 877-253-0084
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6">
          {[
            { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" },
            { icon: "ri-award-line", text: "A+ BBB Rating" },
            { icon: "ri-timer-line", text: "As Fast as 24 Hours" },
            { icon: "ri-price-tag-3-line", text: "Best Price Guarantee" },
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-white/70 text-sm">
              <i className={`${badge.icon} text-[#F6C344]`}></i>
              <span>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}